import React from "react";
import useTitanApp from "../../../hooks/useTitanApp";
import {
  setShowVaccinationPreviewModal,
  setShowVaccineConfirmationModal
} from "../../../dispatchers/patientDispatchers";
import {
  Modal,
  Box,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import { Syringe, FileText } from "lucide-react";
import jsPDF from "jspdf";

export default function VaccineConfirmationModal({ setOpenVaccineDialog }) {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { showVaccineConfirmationModal, vaccinationImageBase64 } =
    patientState || {};

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: darkMode ? "#222" : "#fff",
    boxShadow: 24,
    borderRadius: "16px",
  };

  const handleCloseModal = () => {
    setShowVaccineConfirmationModal(false);
  }
  const generateCertificate = () => {
    // handleOpenAsPDF()
    setShowVaccinationPreviewModal(true);
    setShowVaccineConfirmationModal(false);
  }

  const handleOpenAsPDF = () => {
    if (!vaccinationImageBase64) return;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: "a4",
    });

    // Add the image to the PDF (fit to width, maintain aspect ratio)
    const imgProps = pdf.getImageProperties(vaccinationImageBase64);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(vaccinationImageBase64, "PNG", 0, 0, pdfWidth, pdfHeight);

    // Open PDF in new window/tab
    const blob = pdf.output("blob");
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };

  return (
    <Modal open={showVaccineConfirmationModal}>
      <Box sx={style}>
        <div className="pc-actions-modal-wrapper prescription-preview">
          <div className="pc-actions-modal-header">
            <div className="confirmation-header-title">
              <FileText className="w-5 h-5" color={darkMode ? "#f2f2f2" : "#222"} />
              <h3>Vaccination Complete</h3>
            </div>
            <IoClose
              className="close-icon"
              onClick={handleCloseModal}
              color={darkMode ? "#f2f2f2" : "#222"}
            />
          </div>
          <div className="pc-actions-modal-content">
            <div className="vaccination-container">
              <div className="vaccination-content">
                <div className="icon-wrapper">
                  <Syringe className="icon" />
                </div>
                <h3 className="vaccination-title">
                  Vaccine Administered Successfully
                </h3>
                <p className="vaccination-description">
                  Vaccination has been administered and recorded.
                </p>

                <div className="vaccination-actions">
                  <button
                    onClick={generateCertificate}
                    className="certificate-button">
                    <FileText className="icon-small" />
                    Generate Vaccination Certificate
                  </button>

                  <div className="button-group">
                    <button
                      onClick={handleCloseModal}
                      variant="outline" className="flex-button">
                      Close
                    </button>
                    <button
                      onClick={() => {
                        setShowVaccineConfirmationModal(false);
                        setOpenVaccineDialog(true);
                      }}
                      variant="outline"
                      className="flex-button"
                    >
                      Record Another
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Box>
    </Modal>
  );
}
